import classNames from "classnames";

const sizes = {
  xs: "size-4",
  sm: "size-8",
  md: "size-12",
  lg: "size-14",
  xl: "size-16",
};

type Props = React.SVGProps<SVGSVGElement> & {
  size?: keyof typeof sizes;
};

export default function Loading({ className, size = "md", ...props }: Props) {
  return (
    <svg
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      {...props}
      className={classNames(className, sizes[size], "animate-spin")}
    >
      <g>
        <path
          d="M30 16C30 17.8385 29.6379 19.659 28.9343 21.3576C28.2308 23.0561 27.1995 24.5995 25.8995 25.8995C24.5995 27.1995 23.0561 28.2307 21.3576 28.9343C19.659 29.6379 17.8385 30 16 30C14.1615 30 12.341 29.6379 10.6424 28.9343C8.94387 28.2307 7.40052 27.1995 6.1005 25.8995C4.80048 24.5995 3.76925 23.0561 3.06569 21.3576C2.36212 19.659 2 17.8385 2 16C2 14.1615 2.36212 12.341 3.06569 10.6424C3.76926 8.94387 4.80049 7.40052 6.10051 6.1005C7.40053 4.80048 8.94388 3.76925 10.6424 3.06568C12.341 2.36212 14.1615 2 16 2C17.8385 2 19.659 2.36212 21.3576 3.06569C23.0561 3.76926 24.5995 4.80049 25.8995 6.10051C27.1995 7.40053 28.2308 8.94388 28.9343 10.6424C29.6379 12.341 30 14.1615 30 16L30 16Z"
          stroke="#F2F4F7"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16 2C18.5819 2 21.1135 2.71399 23.315 4.06304C25.5164 5.41208 27.3019 7.34363 28.4741 9.64413C29.6463 11.9446 30.1594 14.5245 29.9568 17.0984C29.7543 19.6724 28.8439 22.1402 27.3262 24.229C25.8086 26.3178 23.7429 27.9463 21.3576 28.9343C18.9722 29.9224 16.36 30.2315 13.8099 29.8276C11.2598 29.4237 8.87103 28.3225 6.90773 26.6457C4.94443 24.9689 3.48306 22.7818 2.68521 20.3262"
          stroke="#7F56D9"
          strokeWidth="4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
